<template>
    <div class="c-m-loader">
        <div class="c-m-loader__icon-wrapper">
            <div class="c-m-loader__icon">
                <icon :icon="'spinner'"></icon>
            </div>
        </div>
        <div v-if="heading" class="c-m-loader__content">
            <p class="c-m-loader__heading">{{heading}}</p>
        </div>
    </div>
</template>

<script>
    import Icon from '../atoms/AtomIcon.vue';

    export default {
        props: {
            heading: {
                default: 'Laddar...',
                type: String
            }
        },
        components: {
            Icon
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeLoader.vue